<template>
  <div class="main">
    <div class="pageTitle">
       <p>按组织机构查询</p>
      <div style="float:right">
        <currentDate @pageReadyFunc='pageReadyFunc'></currentDate>
      </div>
    </div>

    <div class="searchArea">
      <div class="weekly_search">
        <div class="search_input">
          <el-input v-model="listQuery.Parameters.organizationName" autocomplete="off" readonly></el-input>
          <div class="input_chooseBtn">
            <el-button type="text" size="medium" @click="showChooseOrganizationView">选择</el-button>
            <el-button type="text" size="medium" @click="clearOrganization">清除</el-button>
          </div>
        </div>
        <el-select
          v-model="listQuery.Parameters.organizationSearchMode"
          placeholder
         style="width: 250px;">
          <el-option
            v-for="item in organizationSearchModeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <div class="search_select">
          <el-select v-model="listQuery.Parameters.year" placeholder style="width: 80px;" popper-class="selectYear">
            <el-option v-for="item in yearList" :key="item.id" :label="item.Name" :value="item.id"></el-option>
          </el-select>
          <el-select v-model="listQuery.Parameters.month" placeholder  style="width: 60px;"> 
            <el-option v-for="item in monthList" :key="item.id" :label="item.Name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div style="display: inline-block;">
        <el-button size="small" @click="searchTable">查询</el-button>
        <!-- <el-button type="text" class="searchTemp" @click="exportToExcel">下载工时</el-button> -->
      </div>
      </div>

    </div>

 <div class="tableContainer" style="top: 120px;">
   <div class="tableContent">
        <el-table :data="weekportList" border stripe>
          <el-table-column prop="week" label="周次" width="170"></el-table-column>
          <el-table-column prop="userName" label="已填报人员">
            <template slot-scope="props">
              <div v-for="(item,index) in props.row.completedUserList" :key="index" class="attachmentBox">
                <el-button
                  size="mini"
                  type="text"
                  @click="showWeeklyReportView(props.row,item)"
                >{{item.name}}、</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="year" label="未填报人员">
            <template slot-scope="props">
              <div
                v-for="item in props.row.uncompletedUserList"
                :key="item.id"
                class="attachmentBox"
              >
                <span>{{item.name}}、</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
     
    </div>
    <weeklyReportView ref="weeklyReportView"
      :weeklyReportViewProps="weeklyReportViewProps"
      :currentLineInfo="currentLineInfo"></weeklyReportView>
    
    <chooseOrganization ref="chooseOrganization" 
      :propsData="organizationChooseViewProps" 
      @chooseOrganizationCallback="chooseOrganizationCallback">
     </chooseOrganization>

  </div>
</template>
<script>
import { dateFtt } from "@/utils/auth.js";
import weeklyReportView from "../common/weeklyReportView";
import currentDate from "../common/currentDate";
import chooseOrganization from "../common/chooseOrganization";

export default {
  name: "statusListByMonth",
  components: { chooseOrganization,weeklyReportView, currentDate },
  data() {
    return {
      currentWeekInfo: {},
      weeklyReportViewProps: {
        visible: false
      },
      organizationChooseViewProps: {
        visible: false
      },
      chooseVisible: false,
      listQuery: {
        PagingInfo: {
          currentPage: 1,
          totalPage: 0,
          pageSize: 10,
          totalCount: 0
        },
        OrderBy: "",
        Parameters: {
          organizationSearchMode: 0,
          organizationId: this.$userContext.getOrganizationId(),
          organizationName: this.$userContext.getOrganizationName(),
          year: "",
          month: ""
        }
      },
      currentLineInfo: {},
      organizationSearchModeList: [
        { id: 0, name: "当前组织机构及下级所有组织机构" },
        { id: 1, name: "仅当前组织机构" }
      ],
      listQueryByOrganization: {
        organizationId: "",
        year: 0,
        weekOfYear: 0,
        searchMode: 0
      },
      monthList: [
        { id: "1", name: "1" },
        { id: "2", name: "2" },
        { id: "3", name: "3" },
        { id: "4", name: "4" },
        { id: "5", name: "5" },
        { id: "6", name: "6" },
        { id: "7", name: "7" },
        { id: "8", name: "8" },
        { id: "9", name: "9" },
        { id: "10", name: "10" },
        { id: "11", name: "11" },
        { id: "12", name: "12" }
      ],
      yearList: [],
      weekportList: []
    };
  },
  // filters: {
  //   currentTimeShow: function(value) {
  //     return dateFtt("yyyy年MM月dd日 EEE ", new Date(value));
  //   }
  // },
  mounted() {
    // this.pageReadyFunc();
  },
  methods: {
    //获取当前日期后的回调
    pageReadyFunc(currentWeekInfo) {
      this.currentWeekInfo = currentWeekInfo;
      this.listQuery.Parameters.year = new Date(
        this.currentWeekInfo.now
      ).getFullYear();
      this.listQuery.Parameters.month =
        new Date(this.currentWeekInfo.now).getMonth() + 1;
      //月份的数组不能超过当前月
      // this.monthList = this.monthList.slice(
      //   0,
      //   new Date(this.currentWeekInfo.now).getMonth() + 1
      // );
      this.getYearList();
      this.searchTable();
    },
    //获取时间
    getYearList() {
      this.$dateTimeHelperApi.getYearList().then(res => {
        if (res.data.successful) {
          this.yearList = [];
          let list = res.data.data;
          list.forEach(item => {
            this.yearList.push({ id: item, name: item });
          });
        }
      });
    },
    searchTable() {

       if(this.listQuery.Parameters.organizationId == null || this.listQuery.Parameters.organizationId == ""){
        this.listQuery.Parameters.organizationId = this.$userContext.getOrganizationId();
        this.listQuery.Parameters.organizationName = this.$userContext.getOrganizationName();
      }

      let queryObj = {
        organizationId: this.listQuery.Parameters.organizationId,
        organizationSearchMode: this.listQuery.Parameters.organizationSearchMode,
        month: this.listQuery.Parameters.month,
        year: this.listQuery.Parameters.year,
        organizationIdPath: ""
      };

      if (this.listQuery.Parameters.organizationSearchMode == 0) {
        queryObj.organizationIdPath = this.listQuery.Parameters.organizationId;
        queryObj.organizationId = "";
      } else {
        queryObj.organizationId = this.listQuery.Parameters.organizationId;
        queryObj.organizationIdPath = "";
      }

      this.$reportApi.getUserWeeklyReportStatusListByMonth(queryObj).then(res => {
        if (res.data.successful) {
          this.weekportList = res.data.data;
          this.weekportList.forEach(item => {
            item.week =
              dateFtt("MM/dd", item.monday) +
              "-" +
              dateFtt("MM/dd", item.sunday);
          });
          // this.listQuery.PagingInfo.totalCount =
          //   res.data.data.pagingInfo.totalCount;
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },
    handleSizeChange(val) {
      this.listQuery.PagingInfo.pageSize = val;
      this.searchTable();
    },
    handleCurrentChange(val) {
      this.listQuery.PagingInfo.currentPage = val;
      this.searchTable();
    },

    showWeeklyReportView(current, user) {
      this.currentLineInfo = current;
      let queryObj = {
        userId: user.id,
        year: current.year,
        weekOfYear: current.weekOfYear
      };
      this.$refs.weeklyReportView.showByUser(queryObj);
    },

    //选择组织机构
    showChooseOrganizationView() {
      let organizationId = "";

      if(this.$userContext.checkAuthorizationAny(["WeeklyReport_Search_ByOrganization_All"]) == false)
      {
           organizationId = this.$userContext.getOrganizationId();
      }
      
      this.$refs.chooseOrganization.show(organizationId);
    },

    clearOrganization() {
      this.listQuery.Parameters.organizationId = "";
      this.listQuery.Parameters.organizationName = "";
    },
    chooseOrganizationCallback(data) {
      this.listQuery.Parameters.organizationId = data.id;
      this.listQuery.Parameters.organizationName = data.name;
    },
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.search_input {
  width: 220px;
  position: relative;
  display: inline-block;
  margin-right: 10px;
}
.search_select {
  display: inline-block;
  margin-left: 20px;
}
.weekly_search {
  
  margin-top: 20px;
}
.attachmentBox {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/views/weeklyReport/statusListByMonth.vue